module.exports = __webpack_public_path__ + "static/media/lock.f8fbb81d.svg";